<div class="custom-tooltip" [class.show]="isShow">
  {{ text }}
</div>